import { Prop, Watch } from "vue-property-decorator";
import { ServerProcessData } from "../../data/serverProcessData";
import { RequestsStates } from "../../data/enums/requestsStates";
import { getModule } from "vuex-module-decorators";
import { ContractModel } from "../../models/contracts/contractModel";
import { ContractsStore } from "../../store/modules/contracts";
import IAlertService from "../../services/alert/IAlertService";
import { container } from "@/inversify.config";
import { DiTokens } from "../../services/diTokens";
import { appConfig } from "../../config/index";
import { clientTime } from "../../utilities/index";
import i18n from "@/i18n";
import Vue from "vue";
import {DeclarationData, DeclarationPropertyValueData} from "../../data";

export class OperationModalVue extends Vue {

  @Watch("dialog", { immediate: true })
  dialogToggle(val: boolean) {
    if (!val) this.operMoreInfo = false;
  }

  // stores and services: 

  /**Стор счетов */
  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  /**
   * Сервис вывода уведомлний
   */
  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  // props and data:

  @Prop() details!: any;

  @Prop() dialog!: boolean;

  @Prop() loading!: boolean;

  @Prop() selectedColor!: string;

  @Prop() process!: ServerProcessData;

  @Prop() acceptedStates!: Array<RequestsStates>;
  
  @Prop() declaration!: DeclarationData;

  createTemplateMode: boolean = false;

  operMoreInfo: boolean = false;

  // computed:

  get requestData(): any {
    return this.details?.Details;
  }

  get operationData(): any {
    return this.details?.OperationData;
  }

  get respondentData(): any {
    return this.details?.RespondentData
  }

    /** Счет  */
  get contract(): ContractModel {
    if (this.$route.params.contractId)
      return this.contractsStore.contracts.getContract(this.$route.params.contractId);
    else if (this.$route.name == 'Home' && this.contractsStore.contracts.HomeContract)
      return this.contractsStore.contracts.HomeContract;
    return null;
  }

  // methods:

  textValue(detail: DeclarationPropertyValueData): string {
    if (this.declaration == null)
      return detail.Value;

    for (const key in this.declaration.Properties)
    {
      const prop = this.declaration.Properties[key];
      if (prop.Caption == detail.Key && prop.MultiSelect)
      {
        return detail.Value.replaceAll(',', "<br>");
      }
      else
      {
        return detail.Value;
      }
    }
  }
  
  stringRequestState(state: RequestsStates, desc: string, denialRequest: string = ""): string {    
    if (denialRequest)
    {
      return denialRequest
    }
    
    let stringState = "";
    switch (state) {
      case RequestsStates.Executed:
        stringState = i18n.t("main.operation.form.stateExecuted").toString();
        break;
      case RequestsStates.Prepared:
      case RequestsStates.Preparing:
      case RequestsStates.Executing:
        stringState = i18n.t("main.operation.form.stateExecuting").toString();
        break;
      case RequestsStates.PrepareError:
      case RequestsStates.ExecuteError:
      case RequestsStates.Denied:
        stringState = i18n
          .t("main.operation.form.stateDenied", { errorText: desc })
          .toString();
        break;
      default:
        stringState = i18n.t("main.operation.form.stateDenied").toString();
        break;
    }
    return stringState;
  }

  createTemplate() {
    this.createTemplateMode = true;
  }

  getOperStateIconClass(state: RequestsStates) {
    let st: string = "";
    let acceptedState: RequestsStates = 0;
    if (this.acceptedStates && this.acceptedStates.length)
      acceptedState = this.acceptedStates.find((aState: RequestsStates) => aState === state);
    if (acceptedState || !this.acceptedStates) {
      switch (state) {
        case RequestsStates.Executed:
          st = "success-icon";
          break;
        case RequestsStates.Executing:
          st = "wait-icon";
          break;
        case RequestsStates.ExecuteError:
        case RequestsStates.Denied:
          st = "error-icon";
          break;
        default:
          break;
      }
    }
    return st;
  }

  async downloadProcessAtachment(file: any): Promise<void> {
    try {
      if (!file)
        throw 'Не выбран файл для скачивание';

      window.open(`${appConfig.apiUrl}WebClient/GetAttachment?id=${file.Id}&clientTime=${clientTime()}&typeSource=0`, 'download');
    } catch (e: any) {
      this.alertService.error(e.message);
    } 
  }

  isSucessOper(state: RequestsStates) {
    return state == RequestsStates.Executed;
  }

  isExecutingOper(state: RequestsStates) {
    return state == RequestsStates.Executing;
  }

  repeatOper(id: number) {
    this.$router.push("/operation/2/" + id);
  }

  destroyOperation() {
    this.$emit("hideSelf");
  }
}
